import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { checkPremiumExpiration } from '../lib/api';
import { Crown, X, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export default function PremiumExpirationBanner() {
  const [data, setData] = useState<any>(null);
  const [dismissed, setDismissed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const key = 'dd_expiry_dismissed';
    const lastDismissed = sessionStorage.getItem(key);
    if (lastDismissed) {
      setDismissed(true);
      return;
    }
    (async () => {
      try {
        const res = await checkPremiumExpiration();
        if (res.data?.expiring_soon || res.data?.cancelled) {
          setData(res.data);
        }
      } catch { /* silent */ }
    })();
  }, []);

  if (dismissed || !data) return null;

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('dd_expiry_dismissed', '1');
  };

  return (
    <div data-testid="premium-expiration-banner" className="mx-4 mt-2 mb-1 rounded-xl bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 px-4 py-3 flex items-center gap-3">
      <Crown size={18} className="text-amber-500 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-xs font-semibold text-amber-800">
          {data.cancelled
            ? `Your ${data.tier} plan has been cancelled`
            : `Your ${data.tier} plan expires in ${data.days_left} day${data.days_left !== 1 ? 's' : ''}`}
        </p>
        <p className="text-[10px] text-amber-600 mt-0.5">
          {data.cancelled
            ? 'Access continues until your billing period ends. Renew to keep your features.'
            : 'Renew now to avoid losing your premium features.'}
        </p>
      </div>
      <Button
        size="sm"
        className="shrink-0 rounded-full bg-amber-500 hover:bg-amber-600 text-white text-[10px] h-7 px-3"
        onClick={() => navigate('/subscription')}
        data-testid="expiry-renew-btn"
      >
        Renew <ArrowRight size={10} className="ml-1" />
      </Button>
      <button
        onClick={handleDismiss}
        className="text-amber-400 hover:text-amber-600 shrink-0"
        data-testid="expiry-dismiss-btn"
      >
        <X size={14} />
      </button>
    </div>
  );
}
